import { ArrowRightOutlined } from "@ant-design/icons";
import { Flex, Space, Steps, Tag, Typography } from "antd";
import { WO_STATUS_TRANSITIONS } from "../constants/woStatusTransitions";

const STATUS_LABELS: Record<string, string> = {
  NEW: "New",
  IN_PROGRESS: "In Progress",
  STANDBY: "Standby",
  IN_REVIEW: "In Review",
  DONE: "Done",
};

const STATUS_COLORS: Record<string, string> = {
  NEW: "blue",
  IN_PROGRESS: "orange",
  STANDBY: "red",
  IN_REVIEW: "purple",
  DONE: "green",
};

const LINEAR_STEPS = ["NEW", "IN_PROGRESS", "IN_REVIEW", "DONE"] as const;

type WOStatusIndicatorProps = {
  currentStatus: string;
  role: "management" | "field";
};

export const WOStatusIndicator = ({ currentStatus, role }: WOStatusIndicatorProps) => {
  if (role === "management") {
    const isDelayed = currentStatus === "STANDBY";
    const currentIndex = isDelayed
      ? 1
      : LINEAR_STEPS.indexOf(currentStatus as (typeof LINEAR_STEPS)[number]);
    const stepStatus =
      isDelayed ? "error" : currentStatus === "DONE" ? "finish" : "process";

    return (
      <Flex vertical gap={4}>
        <Steps
          size="small"
          current={currentIndex}
          status={stepStatus}
          items={LINEAR_STEPS.map((s) => ({ title: STATUS_LABELS[s] }))}
        />
        {isDelayed && <Tag color="warning">Standby</Tag>}
      </Flex>
    );
  }

  const fieldActions = WO_STATUS_TRANSITIONS[currentStatus]?.field ?? [];
  const nextLabel = fieldActions[0]?.label ?? null;

  return (
    <Space>
      <Tag color={STATUS_COLORS[currentStatus]}>{STATUS_LABELS[currentStatus]}</Tag>
      {nextLabel && (
        <>
          <ArrowRightOutlined />
          <Typography.Text type="secondary">{nextLabel}</Typography.Text>
        </>
      )}
    </Space>
  );
};
